(function () {
  var t = {
      757: function _(t, e, r) {
        t.exports = r(666);
      },
      666: function _(t) {
        var e = function (t) {
          "use strict";

          var e,
            r = Object.prototype,
            n = r.hasOwnProperty,
            o = "function" == typeof Symbol ? Symbol : {},
            i = o.iterator || "@@iterator",
            a = o.asyncIterator || "@@asyncIterator",
            c = o.toStringTag || "@@toStringTag";
          function u(t, e, r) {
            return Object.defineProperty(t, e, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }), t[e];
          }
          try {
            u({}, "");
          } catch (t) {
            u = function u(t, e, r) {
              return t[e] = r;
            };
          }
          function s(t, e, r, n) {
            var o = e && e.prototype instanceof v ? e : v,
              i = Object.create(o.prototype),
              a = new k(n || []);
            return i._invoke = function (t, e, r) {
              var n = l;
              return function (o, i) {
                if (n === p) throw new Error("Generator is already running");
                if (n === y) {
                  if ("throw" === o) throw i;
                  return N();
                }
                for (r.method = o, r.arg = i;;) {
                  var a = r.delegate;
                  if (a) {
                    var c = P(a, r);
                    if (c) {
                      if (c === d) continue;
                      return c;
                    }
                  }
                  if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                    if (n === l) throw n = y, r.arg;
                    r.dispatchException(r.arg);
                  } else "return" === r.method && r.abrupt("return", r.arg);
                  n = p;
                  var u = f(t, e, r);
                  if ("normal" === u.type) {
                    if (n = r.done ? y : h, u.arg === d) continue;
                    return {
                      value: u.arg,
                      done: r.done
                    };
                  }
                  "throw" === u.type && (n = y, r.method = "throw", r.arg = u.arg);
                }
              };
            }(t, r, a), i;
          }
          function f(t, e, r) {
            try {
              return {
                type: "normal",
                arg: t.call(e, r)
              };
            } catch (t) {
              return {
                type: "throw",
                arg: t
              };
            }
          }
          t.wrap = s;
          var l = "suspendedStart",
            h = "suspendedYield",
            p = "executing",
            y = "completed",
            d = {};
          function v() {}
          function m() {}
          function g() {}
          var w = {};
          w[i] = function () {
            return this;
          };
          var b = Object.getPrototypeOf,
            x = b && b(b(S([])));
          x && x !== r && n.call(x, i) && (w = x);
          var O = g.prototype = v.prototype = Object.create(w);
          function _(t) {
            ["next", "throw", "return"].forEach(function (e) {
              u(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function j(t, e) {
            function r(o, i, a, c) {
              var u = f(t[o], t, i);
              if ("throw" !== u.type) {
                var s = u.arg,
                  l = s.value;
                return l && "object" == typeof l && n.call(l, "__await") ? e.resolve(l.__await).then(function (t) {
                  r("next", t, a, c);
                }, function (t) {
                  r("throw", t, a, c);
                }) : e.resolve(l).then(function (t) {
                  s.value = t, a(s);
                }, function (t) {
                  return r("throw", t, a, c);
                });
              }
              c(u.arg);
            }
            var o;
            this._invoke = function (t, n) {
              function i() {
                return new e(function (e, o) {
                  r(t, n, e, o);
                });
              }
              return o = o ? o.then(i, i) : i();
            };
          }
          function P(t, r) {
            var n = t.iterator[r.method];
            if (n === e) {
              if (r.delegate = null, "throw" === r.method) {
                if (t.iterator.return && (r.method = "return", r.arg = e, P(t, r), "throw" === r.method)) return d;
                r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
              }
              return d;
            }
            var o = f(n, t.iterator, r.arg);
            if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, d;
            var i = o.arg;
            return i ? i.done ? (r[t.resultName] = i.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, d) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, d);
          }
          function E(t) {
            var e = {
              tryLoc: t[0]
            };
            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
          }
          function L(t) {
            var e = t.completion || {};
            e.type = "normal", delete e.arg, t.completion = e;
          }
          function k(t) {
            this.tryEntries = [{
              tryLoc: "root"
            }], t.forEach(E, this), this.reset(!0);
          }
          function S(t) {
            if (t) {
              var r = t[i];
              if (r) return r.call(t);
              if ("function" == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var o = -1,
                  a = function r() {
                    for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                    return r.value = e, r.done = !0, r;
                  };
                return a.next = a;
              }
            }
            return {
              next: N
            };
          }
          function N() {
            return {
              value: e,
              done: !0
            };
          }
          return m.prototype = O.constructor = g, g.constructor = m, m.displayName = u(g, c, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === m || "GeneratorFunction" === (e.displayName || e.name));
          }, t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, g) : (t.__proto__ = g, u(t, c, "GeneratorFunction")), t.prototype = Object.create(O), t;
          }, t.awrap = function (t) {
            return {
              __await: t
            };
          }, _(j.prototype), j.prototype[a] = function () {
            return this;
          }, t.AsyncIterator = j, t.async = function (e, r, n, o, i) {
            void 0 === i && (i = Promise);
            var a = new j(s(e, r, n, o), i);
            return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
          }, _(O), u(O, c, "Generator"), O[i] = function () {
            return this;
          }, O.toString = function () {
            return "[object Generator]";
          }, t.keys = function (t) {
            var e = [];
            for (var r in t) e.push(r);
            return e.reverse(), function r() {
              for (; e.length;) {
                var n = e.pop();
                if (n in t) return r.value = n, r.done = !1, r;
              }
              return r.done = !0, r;
            };
          }, t.values = S, k.prototype = {
            constructor: k,
            reset: function reset(t) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(L), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
            },
            stop: function stop() {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function dispatchException(t) {
              if (this.done) throw t;
              var r = this;
              function o(n, o) {
                return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ("root" === a.tryLoc) return o("end");
                if (a.tryLoc <= this.prev) {
                  var u = n.call(a, "catchLoc"),
                    s = n.call(a, "finallyLoc");
                  if (u && s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (u) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!s) throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function abrupt(t, e) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                  var i = o;
                  break;
                }
              }
              i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
              var a = i ? i.completion : {};
              return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, d) : this.complete(a);
            },
            complete: function complete(t, e) {
              if ("throw" === t.type) throw t.arg;
              return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), d;
            },
            finish: function finish(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), L(r), d;
              }
            },
            catch: function _catch(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                  var n = r.completion;
                  if ("throw" === n.type) {
                    var o = n.arg;
                    L(r);
                  }
                  return o;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(t, r, n) {
              return this.delegate = {
                iterator: S(t),
                resultName: r,
                nextLoc: n
              }, "next" === this.method && (this.arg = e), d;
            }
          }, t;
        }(t.exports);
        try {
          regeneratorRuntime = e;
        } catch (t) {
          Function("r", "regeneratorRuntime = r")(e);
        }
      }
    },
    e = {};
  function r(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var i = e[n] = {
      exports: {}
    };
    return t[n](i, i.exports, r), i.exports;
  }
  r.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return r.d(e, {
      a: e
    }), e;
  }, r.d = function (t, e) {
    for (var n in e) r.o(e, n) && !r.o(t, n) && Object.defineProperty(t, n, {
      enumerable: !0,
      get: e[n]
    });
  }, r.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, r.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var n = {};
  (function () {
    "use strict";

    function t(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    function e(t) {
      return (e = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }
    function o(t, r) {
      for (; !Object.prototype.hasOwnProperty.call(t, r) && null !== (t = e(t)););
      return t;
    }
    function i() {
      return (i = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, r) {
        var n = o(t, e);
        if (n) {
          var i = Object.getOwnPropertyDescriptor(n, e);
          return i.get ? i.get.call(arguments.length < 3 ? t : r) : i.value;
        }
      }).apply(this, arguments);
    }
    function a(t, e) {
      return (a = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }
    function c(t) {
      return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }
    function u(t, e) {
      if (e && ("object" === c(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(t);
    }
    r.r(n), r.d(n, {
      Particles: function Particles() {
        return m;
      },
      default: function _default() {
        return g;
      }
    });
    var s = r(757),
      f = r.n(s);
    var l = require("react");
    var h = r.n(l);
    var p = require("tsparticles"),
      y = require("fast-deep-equal/react");
    var d = r.n(y);
    var v = function v(t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function a(t) {
            try {
              u(n.next(t));
            } catch (t) {
              i(t);
            }
          }
          function c(t) {
            try {
              u(n.throw(t));
            } catch (t) {
              i(t);
            }
          }
          function u(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(a, c);
          }
          u((n = n.apply(t, e || [])).next());
        });
      },
      m = function (r) {
        !function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          Object.defineProperty(t, "prototype", {
            value: Object.create(e && e.prototype, {
              constructor: {
                value: t,
                writable: !0,
                configurable: !0
              }
            }),
            writable: !1
          }), e && a(t, e);
        }(y, r);
        var n,
          o,
          c,
          s,
          l = (c = y, s = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              r = e(c);
            if (s) {
              var n = e(this).constructor;
              t = Reflect.construct(r, arguments, n);
            } else t = r.apply(this, arguments);
            return u(this, t);
          });
        function y(t) {
          var e;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, y), (e = l.call(this, t)).state = {
            library: void 0
          }, e;
        }
        return n = y, (o = [{
          key: "destroy",
          value: function value() {
            this.state.library && (this.state.library.destroy(), this.setState({
              library: void 0
            }));
          }
        }, {
          key: "shouldComponentUpdate",
          value: function value(t) {
            return !d()(t, this.props);
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.refresh();
          }
        }, {
          key: "forceUpdate",
          value: function value() {
            var t = this;
            this.refresh().then(function () {
              i(e(y.prototype), "forceUpdate", t).call(t);
            });
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            v(this, void 0, void 0, f().mark(function t() {
              return f().wrap(function (t) {
                for (;;) switch (t.prev = t.next) {
                  case 0:
                    if (!this.props.init) {
                      t.next = 3;
                      break;
                    }
                    return t.next = 3, this.props.init(p.tsParticles);
                  case 3:
                    return t.next = 5, this.loadParticles();
                  case 5:
                  case "end":
                    return t.stop();
                }
              }, t, this);
            }));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.destroy();
          }
        }, {
          key: "render",
          value: function value() {
            var t = this.props,
              e = t.width,
              r = t.height,
              n = t.className,
              o = t.canvasClassName,
              i = t.id;
            return h().createElement("div", {
              className: n,
              id: i
            }, h().createElement("canvas", {
              className: o,
              style: Object.assign(Object.assign({}, this.props.style), {
                width: e,
                height: r
              })
            }));
          }
        }, {
          key: "refresh",
          value: function value() {
            return v(this, void 0, void 0, f().mark(function t() {
              return f().wrap(function (t) {
                for (;;) switch (t.prev = t.next) {
                  case 0:
                    return this.destroy(), t.next = 3, this.loadParticles();
                  case 3:
                  case "end":
                    return t.stop();
                }
              }, t, this);
            }));
          }
        }, {
          key: "loadParticles",
          value: function value() {
            var t;
            return v(this, void 0, void 0, f().mark(function e() {
              var r,
                n,
                o = this;
              return f().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (r = function r(t) {
                      return v(o, void 0, void 0, f().mark(function e() {
                        return f().wrap(function (e) {
                          for (;;) switch (e.prev = e.next) {
                            case 0:
                              if (this.props.container && (this.props.container.current = t), this.setState({
                                library: t
                              }), !this.props.loaded) {
                                e.next = 5;
                                break;
                              }
                              return e.next = 5, this.props.loaded(t);
                            case 5:
                            case "end":
                              return e.stop();
                          }
                        }, e, this);
                      }));
                    }, !this.props.url) {
                      e.next = 7;
                      break;
                    }
                    return e.next = 4, p.tsParticles.loadJSON(this.props.id, this.props.url);
                  case 4:
                    e.t0 = e.sent, e.next = 10;
                    break;
                  case 7:
                    return e.next = 9, p.tsParticles.load(this.props.id, null !== (t = this.props.params) && void 0 !== t ? t : this.props.options);
                  case 9:
                    e.t0 = e.sent;
                  case 10:
                    return n = e.t0, e.next = 13, r(n);
                  case 13:
                  case "end":
                    return e.stop();
                }
              }, e, this);
            }));
          }
        }]) && t(n.prototype, o), Object.defineProperty(n, "prototype", {
          writable: !1
        }), y;
      }(l.Component);
    m.defaultProps = {
      width: "100%",
      height: "100%",
      options: {},
      style: {},
      url: void 0,
      id: "tsparticles"
    };
    var g = m;
  })();
  var o = exports;
  for (var i in n) o[i] = n[i];
  n.__esModule && Object.defineProperty(o, "__esModule", {
    value: !0
  });
})();